import { Grid, Select, Switch } from '@mantine/core';

import InputAndLabelGridRow from 'common/Components/InputAndLabelGridRow';

import { useProjectsTranslations } from '../hooks';
import { useSamplePlanFormContext } from '../samplePlanFormContextV2';

import { useCarbonPlanConfigQuery } from './queries';

const WetAggregateStabilityDetails = () => {
  const translations = useProjectsTranslations();

  const samplePlanForm = useSamplePlanFormContext();
  const formValues = samplePlanForm.getValues();

  const { samplePlanConfig } = useCarbonPlanConfigQuery();
  const { wet_aggregate_stability } = samplePlanConfig || {};

  return (
    <Grid mt="md">
      <InputAndLabelGridRow
        elemId="wet-aggregate-stability-switch"
        label={translations.wetAggregateStabilityDetails}
        fw="bold"
        size="xl"
        span={5}
        input={
          <Switch
            id="wet-aggregate-stability-switch"
            {...samplePlanForm.getInputProps('isWetAggregateStability', {
              type: 'checkbox',
            })}
            checked={formValues.isWetAggregateStability}
            onChange={() =>
              samplePlanForm.setFieldValue(
                'isWetAggregateStability',
                !formValues.isWetAggregateStability,
              )
            }
          />
        }
      />
      {formValues.isWetAggregateStability && (
        <>
          <InputAndLabelGridRow
            elemId="wet-aggregate-stability-density-select"
            label={translations.density}
            span={5}
            input={
              <Select
                data={wet_aggregate_stability?.densities.map((density) => ({
                  value: String(density.value),
                  label: density.label,
                }))}
                id="wet-aggregate-stability-density-select"
                {...samplePlanForm.getInputProps('was_dict.density')}
              />
            }
          />
          <InputAndLabelGridRow
            elemId="wet-aggregate-stability-lab"
            label={translations.lab}
            span={5}
            input={
              <Select
                data={wet_aggregate_stability?.labs || []}
                id="wet-aggregate-stability-lab"
                {...samplePlanForm.getInputProps('was_dict.lab')}
                value={formValues.was_dict.lab}
                onChange={(value) => value && samplePlanForm.setFieldValue('was_dict.lab', value)}
                allowDeselect={false}
              />
            }
          />
        </>
      )}
    </Grid>
  );
};

export default WetAggregateStabilityDetails;
